import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import PictureThumbnail from '../../../SharedComponent/PictureThumbnail/PictureThumbnail';
import translations from '../.vocab';

import imageCenter from './images/image_center.jpg';
import imageLeft from './images/image_left.jpg';
import imageRight from './images/image_right.jpg';

import * as styles from './SocialProofSection.css';

const SocialProofSection = () => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="small">
      <Box
        gap="xxsmall"
        display="flex"
        justifyContent="flexStart"
        alignItems="center"
        marginTop="xxsmall"
      >
        <Box className={styles.thumbnailsContainer}>
          <PictureThumbnail
            imageSrc={imageLeft}
            imageAlt=""
            size="small"
            thumbnailStyle={styles.thumbnail.left}
          />
          <PictureThumbnail
            imageSrc={imageCenter}
            imageAlt=""
            size="small"
            thumbnailStyle={styles.thumbnail.center}
          />
          <PictureThumbnail
            imageSrc={imageRight}
            imageAlt=""
            size="small"
            thumbnailStyle={styles.thumbnail.right}
          />
        </Box>
        <Text size="small" tone="secondary">
          {t(
            '73% found the refinement helpful in surfacing better-matched roles.',
          )}
        </Text>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        paddingLeft="xsmall"
        className={styles.quoteBlock}
        flexGrow={1}
      >
        <Text size="xsmall">
          {t(
            "Seek's recommendations helped me cut through the noise — it felt like the jobs were picked just for me.",
          )}
        </Text>
      </Box>
    </Stack>
  );
};

export default SocialProofSection;
